import { defaultLocale } from '../../../../consts/locale';
import { BusinessTimezoneTypes, BusinessInfo } from '../../../../types';
import {
  BasedOn,
  GetBookingsSettingsResponse,
} from '@wix/ambassador-bookings-v2-bookings-settings/types';

export const mapResponseToBusinessInfo = (
  bookingsSettingsResponse: GetBookingsSettingsResponse,
): BusinessInfo => {
  const { bookingsSettings } = bookingsSettingsResponse!;
  const { locale, timeZone, address } = bookingsSettings?.siteProperties!;

  const allowTimezoneSwitch =
    bookingsSettings?.displayTimeZone?.customerCanChange ?? false;

  const defaultTimezoneToUse =
    bookingsSettings?.displayTimeZone?.basedOn === BasedOn.CUSTOMER_TIME_ZONE
      ? BusinessTimezoneTypes.USER
      : BusinessTimezoneTypes.BUSINESS;

  return {
    allowTimezoneSwitch,
    defaultTimezoneToUse,
    businessTimezone: timeZone!,
    dateRegionalSettingsLocale: locale?.languageCode
      ? [locale.languageCode, locale.country].filter(Boolean).join('-')
      : defaultLocale,
    formattedAddress: address?.googleFormattedAddress,
    bookingsSettings,
  };
};
